/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

export enum Authorities {
  ROLE_DEV_VIEW_ONLY = 'ROLE_DevViewOnly',
  ROLE_SIGNAL_QUALITY_VIEW_ONLY = 'ROLE_SignalQualityViewOnly',
  ROLE_MPT_MENU_VIEW = 'ROLE_MptMenuView',
  ROLE_MISSION_PLANS_VIEW = 'ROLE_MissionPlansView',
  ROLE_DETAILED_CONNECTION_STATS = 'ROLE_DetailedConnectionStatistics',
  ROLE_VIEW_HISTORICAL_CHARTS = 'ROLE_ViewHistoricalCharts',
  ROLE_TDS_STCR_RW = 'ROLE_TDS_STCR_RW',
  ROLE_TDS_STCR_APPROVER = 'ROLE_TDS_STCR_APPROVER',
  ROLE_MANUAL_DOWNTIME = 'ROLE_ManualDowntime',
  ROLE_TRANSPORT_MONITORING_VIEW = 'ROLE_TransportMonitoringView',
  ROLE_PROVISIONING_RW = 'ROLE_PROVISIONING_RW',
  ROLE_HNA_APPROVER = 'ROLE_HNA_APPROVER',
  ROLE_GPS_SA_OVERLAY = 'ROLE_GPS_SA_OVERLAY',
  ROLE_TDS_ROLE_RW = 'ROLE_TDS_ROLE_RW',
  ROLE_TDS_CLIENT_RW = 'ROLE_TDS_CLIENT_RW',
  ROLE_WHATS_NEW_PANEL = 'ROLE_WHATS_NEW_PANEL',
  ROLE_ISAN_CUSTOMER = 'ROLE_ISAN_Customer',
  ROLE_ISAN_DEV = 'ROLE_ISAN_Dev',
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
  rolesInheritedFromOrg: string[];
  orgNum: number;
  orgName: string;
}
